import type { PropType } from 'vue'

export const BdDialogProps = {
  /**
   ** visible(v-model)对话框是否可见
   */
  visible: {
    type: Boolean as PropType<boolean>,
    required: true,
    default: false
  },
  /**
   ** 标题
   */
  title: {
    type: String as PropType<string>,
    default: ''
  },
  /**
   ** 是否开启拖拽
   */
  draggable: {
    type: Boolean as PropType<boolean>,
    default: true
  },
  /**
   ** 关闭前回调
   */
  beforCloseFn: {
    type: Function as PropType<() => void>,
    default: null
  },
  /**
   ** 点击确认回调
   */
  confirmFn: {
    type: Function as PropType<BD.PromiseFn | BD.Fn>,
    default: null
  },
  /**
   ** 是否禁用确认按钮
   */
  confirmDisabled: {
    type: Boolean as PropType<boolean>,
    default: false
  },
  /**
   ** 是否显示确认按钮
   */
  confirmVisible: {
    type: Boolean as PropType<boolean>,
    default: true
  },
  /**
   ** 是否显示取消按钮
   */
  cancelVisible: {
    type: Boolean as PropType<boolean>,
    default: true
  },
  /**
   ** 其余属性
   */
  attrs: {
    type: Object as PropType<Record<string, any>>
  }
}
